export default __webpack_public_path__ + "cabb6153298bd0ea193100247194ec16.svg";